import { CalendarIcon, ZapIcon, TargetIcon, GamepadIcon, MapIcon, type LucideIcon } from 'lucide-react';

export interface Bonus {
  icon: LucideIcon;
  emoji: string;
  title: string;
  value: string;
  text: string;
}

export const bonuses: Bonus[] = [
  {
    icon: CalendarIcon,
    emoji: '🗓️',
    title: 'Plan de Arranque 7 Días',
    value: '9,90€',
    text: 'Siete pasos para organizar recursos, elegir el foco, preparar la primera sesión y dejar la comunicación y revisión previstas. Incluye hojas reutilizables.'
  },
  {
    icon: ZapIcon,
    emoji: '⚡',
    title: 'Sesión Express 15 Minutos',
    value: '12,90€',
    text: 'Recursos para esos días en los que necesitas trabajar un objetivo concreto, tienes poco tiempo o necesitas complementar una sesión.'
  },
  {
    icon: TargetIcon,
    emoji: '🎯',
    title: '30 Entrenamientos Listos para Aplicar',
    value: '14,90€',
    text: '30 sesiones organizadas con objetivos, tareas, tiempos, correcciones y variantes para adaptar el trabajo a tus jugadores. Son parte de las 54 sesiones de la colección.'
  },
  {
    icon: GamepadIcon,
    emoji: '⚽',
    title: '30 Juegos Técnicos para Fútbol Formativo',
    value: '11,90€',
    text: '30 juegos y retos adaptados del Tomo 2, con diagramas, reglas, rotaciones y correcciones. Acceso organizado por habilidad para elegir propuestas según el grupo.'
  },
  {
    icon: MapIcon,
    emoji: '📱',
    title: 'Mapa de Temporada de 36 Semanas',
    value: '9,90€',
    text: 'Organiza los objetivos de tu temporada con una propuesta de planificación de 36 semanas y dos entrenamientos por semana, adaptable al calendario de tu equipo.'
  }
];
